

















































































import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

import Draggable from 'vuedraggable';

@Component({
  components: {
    Draggable,
  },
})
export default class DraggableDataTable extends Vue {
  @Prop({ default: () => [] })
  headers!: Array<any>;

  @Prop({ default: () => ({}) })
  tableData!: any;

  get dragOptions() {
    return {
      group: 'test1',
      onDrop: (event: any) => console.log('onDrop', event),
      onDragstart: (event: any) => console.log('onDragstart', event),
      onDragenter: (event: any) => console.log('onDragenter', event),
      onDragover: (event: any) => console.log('onDragover', event),
      onDragend: (event: any) => console.log('onDragend', event),
    };
  }

  get serverItemsLength() {
    return this.tableData.pagination.itemsLength;
  }

  get tableOptions() {
    const { page, itemsPerPage } = this.tableData.pagination;
    return {
      page,
      itemsPerPage,
    };
  }

  onPagination(pagination: any) {
    this.$emit('pagination', pagination);
  }

  move(event: any, item: any) {
    this.$emit('move', item?.relatedContext?.element || null);
    console.log('move', item, event);
  }

  change(event: any) {
    this.$emit('dragChange', event);
    console.log('change', event);
  }

  clickRow(event: any) {
    this.$emit('clickRow', event);
  }
}

